<template>
    <div class="position-thank-you-wrapper">
        <div class="position-thank-you">
            <h1 class="new-headline-lg text-violet">Thank you for applying!</h1>
            <div>
                <p class="new-text-lg text-color-default">We're thrilled that you're interested in becoming part of our Vitadio team. We just wanted to let you know that we received your application and we'll contact you within the next 14 days.</p>
                <figure>
                    <img src="/imgs/web/svg/letter-en.svg" alt="">
                </figure>
                <p class="new-text-lg text-color-default">In the meantime, feel free to reach out to our People Operations team in case of any questions.</p>
            </div>
            <figure>
                <img src="/imgs/web/svg/letter-en.svg" alt="">
            </figure>

            <locket :name="this.locket"></locket>
        </div>
        <v-button
            label="Back to open positions"
            href="/career#anchor-open-positions"
        > 
        </v-button>
    </div>
</template>

<script>
export default {
    props: {
        locket: {
            type: String,
            required: true,
        }
    },
    data(){
        return {}
    },
    created() {
        window.scrollTo(0,0)
    }
}
</script>

